import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {FilterClause} from 'common/report/insights/models/filter-clause';
import {FilterSection} from 'common/report/insights/models/section';
import {DETERMINER_MAPPING} from 'common/report/insights/util/constants';
import {FiltersOperator} from 'common/query-builder/query-entry-section/types';
import {findKeyByValue} from 'common/util/typescript';

import {FilterDeterminer} from './types';

/**
 * Transforms FilterSection clauses to propertyFilters
 */
export function getPropertyFilters(filterClauses: FilterClause[]): PropertyFilter[] {
  return filterClauses.map((clause) => clause.toPropertyFilter());
}

export function getPropertyFiltersFromBookmark(bookmarkFilters: TODO): PropertyFilter[] {
  return bookmarkFilters.map((filter) => new FilterClause(filter).toPropertyFilter());
}

export function getPropertyFiltersOperator(determiner: FilterDeterminer): FiltersOperator {
  return findKeyByValue(DETERMINER_MAPPING, determiner);
}

/**
 * Transforms propertyFilters to FilterSection
 */
export function getFilterSection(
  filters: Array<Partial<PropertyFilter>>,
  filterOperator: FiltersOperator,
): FilterSection {
  const clauses = filters.map((item) => FilterClause.fromPropertyFilter(item));
  const determiner = DETERMINER_MAPPING[filterOperator];

  return new FilterSection({
    clauses,
    determiner,
  });
}
